(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react'; // import Header from './Header';
// import Footer from './Footer';
// import AdminLayout from './admin/AdminLayout';
// import PublicLayout from './PublicLayout';

import loadable from '@loadable/component';
const AdminLayout = loadable({
  resolved: {},

  chunkName() {
    return "admin-AdminLayout";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "admin-AdminLayout" */
  './admin/AdminLayout'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./admin/AdminLayout");
    }

    return eval('require.resolve')("./admin/AdminLayout");
  }

});
const PublicLayout = loadable({
  resolved: {},

  chunkName() {
    return "PublicLayout";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "PublicLayout" */
  './PublicLayout'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./PublicLayout");
    }

    return eval('require.resolve')("./PublicLayout");
  }

}); // import QuoteBottom from './quote-bottom';
// import AdminHeader from './admin/AdminHeader';
// import AdminFooter from './admin/AdminFooter';
// import AdminMenu from './admin/AdminMenu';
// const Layout = ({ isLogged, children, location }) => {
//   const isLogin = !isLogged || location.indexOf('/login') >= 0;
//   // console.log('isLogin', isLogin);
//   return (
//     <>
//       {isLogin && <Header location={location} />}
//       {children}
//       {isLogin && <QuoteBottom />}
//       {isLogin && <Footer />}
//     </>
//   );
// };
//Inicio
// const publicLayout = (children, location, isLogged) => (
//   <>
//     <Header location={location} isLogged={isLogged} />
//     {children}
//     <Footer isLogged={isLogged} />
//   </>
// );
//Fin
// const adminLayout = (children, location, isLogged) => (
//   <div className="admin-layout">
//     <AdminMenu />
//     <div className="admin-layout__right">
//       <AdminHeader location={location} isLogged={isLogged} />
//       <div className="content">{children}</div>
//       <AdminFooter isLogged={isLogged} />
//     </div>
//   </div>
// );

const Layout = props => {
  const {
    isLogged,
    children,
    location
  } = props;
  const isLogin = location.indexOf('/login') >= 0;
  const isAdmin = location.indexOf('/admin') >= 0; // console.log('isAdmin', isAdmin);

  if (isAdmin && isLogged) {
    return /*#__PURE__*/React.createElement(AdminLayout, {
      location: location,
      isLogged: isLogged
    }, children);
  }

  if (isLogin || isAdmin && !isLogged) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  return /*#__PURE__*/React.createElement(PublicLayout, {
    location: location,
    isLogged: isLogged
  }, children); // return publicLayout(children, location, isLogged);
};

const _default = Layout;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(AdminLayout, "AdminLayout", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/Layout.jsx");
  reactHotLoader.register(PublicLayout, "PublicLayout", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/Layout.jsx");
  reactHotLoader.register(Layout, "Layout", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/Layout.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/Layout.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();